import React from 'react';

import TickIcon from 'icons/ic-tick.svg';
import PropTypes from 'prop-types';

import Toast from 'components/application/Toast';

export default function SuccessToast({
  additionalContent,
  message,
  onBurnToast,
  toastKey,
}) {
  return (
    <Toast
      burn={onBurnToast}
      burnTimer={7000}
      contents={
        <>
          <div className='toast__icon tw-bg-green-500'>
            <TickIcon
              className='[&_polygon]:tw-fill-white'
              height={20}
              width={20}
            />
          </div>
          <div className='toast__text'>{message}</div>
          {additionalContent}
        </>
      }
      modifiers='no-undo'
      toastKey={toastKey}
    />
  );
}

SuccessToast.propTypes = {
  message: PropTypes.node,
  additionalContent: PropTypes.node,
};
